import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';
import { Exam } from './../models/exam';

class ExamApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetExams(termSchoolId: number) {
        const { data } = await this.httpClient.get(`/exam?termSchoolId=${termSchoolId}`);
        return data;
    }

    async GetExamTypes() {
        const { data } = await this.httpClient.get(`/exam/types`);
        return data;
    }

    async AddNewExam(exam: Exam) {
        const { data } = await this.httpClient.post('/exam', exam);
        return data;
    }

    async UpdateExam(exam: Exam) {
        const { data } = await this.httpClient.put('/exam', exam);
        return data;
    }

    async DeleteExam(examScheduleId: number) {
        const { data } = await this.httpClient.delete(`/exam?examScheduleId=${examScheduleId}`);
        return data;
    }

    async UploadExamFile(examFile: any) {
        const { data } = await this.httpClient.post('/exam/uploadSchedule', examFile);
        return data;
    }

    async DeleteExamFile(fileId: number) {
        const { data } = await this.httpClient.delete(`/exam/deleteSchedule?fileId=${fileId}`);
        return data;
    }
}

export default ExamApi;
